export default "<p>Dashboard</p>\n"